module.exports = __webpack_public_path__ + "img/Fe-Symbol.73074d7a.jpg";